module.exports = __webpack_public_path__ + "img/friend.0a6a553b.svg";